import axios from 'axios'

// 是否需要加密
sessionStorage.setItem('postCrypto', 'false')
// 是否需要usb校验
sessionStorage.setItem('usbCrypto', 'false')

async function getConfig() {
    const { data: config } = await axios.get('/store/config/web-config.json')
    sessionStorage.setItem('config', JSON.stringify(config))
}

getConfig()